module.exports = __webpack_public_path__ + "static/media/emilie-win.688c46d5.png";